import React from 'react';

// icons
import img1 from './icons/black-big-car-side-view.png';
import img2 from './icons/mecanica.png';
import img3 from './icons/legal.png';
import img4 from './icons/car.png';
import img5 from './icons/police.png';

import styles from './feactures.module.scss';
import clsx from "clsx";

export const FeaturesItem = () => {
    return (
        <div className={styles.container}>
            <div className={clsx("w-full flex flex-col flex-d-center text-center", styles.titleContainer)}>
                <h3>El historial completo de tu vehículo</h3>
            </div>
            <div className={styles.featureContainer}>
                <Item
                    width="93px"
                    height="45px"
                    title="Información de uso"
                    img={img1}
                    features={["Propietarios", "Transporte público", "Consumo y emisiones"]}/>

                <Item
                    width="71px"
                    height="60px"
                    title="Información mecánica"
                    img={img2}
                    features={["Remate por accidente", "Revisiones técnicas", "Recalls"]}/>

                <Item
                    width="72px"
                    height="59px"
                    title="Información Legal"
                    img={img3}
                    features={["Limitaciones al dominio", "Encargos por robo", "PCV y SOAP"]}/>

                <Item
                    width="59px"
                    height="61px"
                    title="Identificación"
                    img={img4}
                    features={["Características básicas", "Nº Motor, Chasis y VIN"]}/>

                <Item
                    width="86px"
                    height="67px"
                    title="Multas e infracciones"
                    img={img5}
                    features={["Pasadas pendientes", "Multas e infracciones"]}/>
            </div>
        </div>
    );
};

const Item = ({title, img, features = [], width, height}) => {
    return (
        <div className={styles.item}>
            <div style={{height: '67px'}} className="flex flex-center flex-d-center">
                <img src={img} alt="img1" height={height} width={width}/>
            </div>
            <p className={styles.title}>{title}</p>
            {
                features.map(item => <p key={item}>{item}</p>)
            }
        </div>
    );
};
